<script setup lang="ts">
import { computed, toRefs } from 'vue'

import type { Color, FontWeight, Size, Tag } from '@ui/types/heading'

const props = withDefaults(
  defineProps<{
    color?: Color
    size?: Size
    tag?: Tag
    weight?: FontWeight
  }>(),
  {
    color: 'default',
    tag: 'div',
    size: 'md',
    weight: 'normal'
  }
)

const { color, size, tag, weight } = toRefs(props)

const elementType = computed(() => (tag.value as string).toLowerCase())
</script>

<template>
  <component
    :is="elementType"
    :class="useTailwindClasses([useTextColor(color), useTextSize(size), useFontWeight(weight)])"
  >
    <slot />
  </component>
</template>
